export const clonePrices = [
  {
    resource: 'dbaas_compute_cores',
    name: {
      ru: 'DBaaS vCPU, Ядра',
      en: 'DBaaS vCPU, Cores'
    }
  },
  {
    resource: 'dbaas_compute_ram',
    name: {
      ru: 'DBaaS RAM, ГБ',
      en: 'DBaaS RAM, GB'
    }
  },
  {
    resource: 'dbaas_volume_gigabytes_local',
    name: {
      ru: 'DBaaS Локальный диск, ГБ',
      en: 'DBaaS Local disk, GB'
    }
  },
  {
    resource: 'dbaas_storage',
    name: {
      ru: 'DBaaS Резервные копии, ГБ',
      en: 'DBaaS Backups, GB'
    }
  }
]